import { render, staticRenderFns } from "./ActivarCredencialAgencia.vue?vue&type=template&id=ceb15f54&scoped=true"
import script from "./ActivarCredencialAgencia.vue?vue&type=script&lang=js"
export * from "./ActivarCredencialAgencia.vue?vue&type=script&lang=js"
import style0 from "./ActivarCredencialAgencia.vue?vue&type=style&index=0&id=ceb15f54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb15f54",
  null
  
)

export default component.exports